import React from "react"
import { NavLink } from "react-router-dom"
import glamorous from "glamorous"
import style from "utils/style"

const HeaderTabLink = ({ title, path, isActive }) => (
  <Link to={path} isActive={isActive} exact>
    {title}
  </Link>
)

export default HeaderTabLink

export const Link = glamorous(NavLink)({
  marginRight: "1.5rem",
  padding: "1.6rem 0 1.6rem 0",
  color: style.colors.silverGray,
  fontSize: "0.65rem",
  textAlign: "center",
  letterSpacing: 1,
  textTransform: "uppercase",
  fontWeight: "600",
  textDecoration: "none",

  whiteSpace: "nowrap",
  "&:hover": {
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: style.colors.silver,
  },
  "&.active": {
    color: style.colors.green,
    borderBottomWidth: 1,
  },
})



// WEBPACK FOOTER //
// ./src/components/HeaderTabLink/index.js